<section class="descricao">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h3>{{ data.TITULO }}</h3>
                <h6>{{ data.TEXTO }}</h6>
            </div>
        </div>
    </div>
</section>